import { render, staticRenderFns } from "./BetTypeSwitcher.vue?vue&type=template&id=37369112"
import script from "./BetTypeSwitcher.vue?vue&type=script&lang=js"
export * from "./BetTypeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports